/** Compile-time constant: non-dev builds fold to `false`, dropping gated code from the bundle. */
export function devToolsEnabled(): boolean {
  return (
    import.meta.env.DEV || import.meta.env.VITE_ENABLE_DEV_TOOLS === "true"
  );
}
